export default __webpack_public_path__ + "static/media/Armbands of the Sundered Skies.0f819d07.jpg";